import React from "react";
import user_ from "../Assets/Images/profile-circle.png";
import fb_ from "../Assets/Images/fb.svg";
import twt_ from "../Assets/Images/youtube_yyfz99.svg";
import insta_ from "../Assets/Images/ig_pc6ylk.svg";
import utube_ from "../Assets/Images/x_r4k9y4.svg";
import linkedin_ from "../Assets/Images/linkdin_tdfxme.svg";
import phone_ from "../Assets/Images/call_ueuxy7.svg";
import message_ from "../Assets/Images/sms_rtu5gt.svg";
import address_ from "../Assets/Images/location_tidbft.svg";
import vpextended_ from "../Assets/Images/valpropheader_rzizom.svg";
import vlogo_ from "../Assets/Images/arrow_2_ia2ar1.svg";
import img1 from "../Assets/Images/COLEAD_yahqm6.png";
import img2 from "../Assets/Images/nigeria-british_a4bja0.jpg";
import img4 from "../Assets/Images/Federal-Ministry-of-Agric_cafd38.jpg";
import img5 from "../Assets/Images/DAWN-Official_mivfzy.jpg";
import img6 from "../Assets/Images/giz_k3fytz.png";
import img8 from "../Assets/Images/east-west-seed-logo_ppdywn.png";
import img9 from "../Assets/Images/Cotecna_gtwzaj.jpg";
import value_icon_1_ from "../Assets/Images/Frame 1000001935.png";
import value_icon_2_ from "../Assets/Images/Frame 1000001935 (2).png";
import value_icon_3_ from "../Assets/Images/Frame 1000001935 (3).png";
import value_icon_4_ from "../Assets/Images/Frame 1000001935 (4).png";
import value_icon_5_ from "../Assets/Images/Frame 1000001935 (5).png";

//Homepge Assest//

//
export const blog_image =
  "https://ajeoba-website.oss-eu-central-1.aliyuncs.com/compressed-images/compressed-images/Quality%20Assurance-min.png";
//
export const arrow_who = vlogo_;
export const vlogo = vlogo_;
export const vpextended = vpextended_;
export const user_icon = user_;
export const fb = fb_;
export const twt = twt_;
export const insta = insta_;
export const utube = utube_;
export const linkedin = linkedin_;
export const phone = phone_;
export const message = message_;
export const address = address_;
//
export const read_more_btn =
  "https://ajeoba-website.oss-eu-central-1.aliyuncs.com/compressed-images/compressed-images/read_more_btn.png";
export const grid =
  "https://ajeoba-website.oss-eu-central-1.aliyuncs.com/compressed-images/compressed-images/grid.png";
export const mission_image =
  "https://ajeoba-website.oss-eu-central-1.aliyuncs.com/compressed-images/compressed-images/mission_image-min.png";
export const vision_image =
  "https://ajeoba-website.oss-eu-central-1.aliyuncs.com/compressed-images/compressed-images/vision_image-min.png";
export const bottom_flour =
  "https://ajeoba-website.oss-eu-central-1.aliyuncs.com/compressed-images/compressed-images/bottom_flour.png";
export const top_flour =
  "https://ajeoba-website.oss-eu-central-1.aliyuncs.com/compressed-images/compressed-images/top_flour.png";
export const use_frame =
  "https://ajeoba-website.oss-eu-central-1.aliyuncs.com/compressed-images/compressed-images/use_frame_2.png";
export const value_bottom =
  "https://ajeoba-website.oss-eu-central-1.aliyuncs.com/compressed-images/compressed-images/value_bottom.png";
export const about_image =
  "https://ajeoba-website.oss-eu-central-1.aliyuncs.com/compressed-images/compressed-images/about_us.png";
export const about_section_1 =
  "https://ajeoba-website.oss-eu-central-1.aliyuncs.com/compressed-images/compressed-images/about_section_1-min.png";
//
export const city =
  "https://ajeoba-website.oss-eu-central-1.aliyuncs.com/compressed-images/compressed-images/city%20%281%29.png";
export const c_buyer =
  "https://ajeoba-website.oss-eu-central-1.aliyuncs.com/website-images/c_buyer.jpg";
export const farming_assoc =
  "https://ajeoba-website.oss-eu-central-1.aliyuncs.com/compressed-images/compressed-images/Home%20banner%20mobile-min.png";
export const proprietary_mobile =
  "https://ajeoba-website.oss-eu-central-1.aliyuncs.com/website-images/Home%20banner%20mobile-min.png";
export const plowing =
  "https://ajeoba-website.oss-eu-central-1.aliyuncs.com/compressed-images/compressed-images/plowing.jpg";
export const finance =
  "https://ajeoba-website.oss-eu-central-1.aliyuncs.com/compressed-images/compressed-images/valprop_1_bzkt8c.jpg";
//
export const patners = [
  {
    img: img1,
  },
  {
    img: img2,
  },
  {
    img: "https://ajeoba-website.oss-eu-central-1.aliyuncs.com/compressed-images/compressed-images/Afrikanische_kyxyow.png",
  },
  {
    img: img4,
  },
  {
    img: img5,
  },
  {
    img: img6,
  },
  {
    img: "https://ajeoba-website.oss-eu-central-1.aliyuncs.com/compressed-images/compressed-images/swagco_lymmk2.png",
  },
  {
    img: img8,
  },
  {
    img: img9,
  },
];
//
export const valuePropImgs = [
  {
    img: "https://ajeoba-website.oss-eu-central-1.aliyuncs.com/compressed-images/compressed-images/Digital%20Infrastructure%20%281%29.png",
    caption: "Digital infrastructure",
    // text: "We bridge the financing gap for smallholder farmers across Nigeria. Using our robust farmer verification and KYC structure, farmers verified on our platform can gain access to small loans & grants to boost agricultural process & increase productivity.",
    text: "The company’s digital platform primarily creates an interface between sellers and buyers of agricultural products and related transactions leveraging information technology to eliminate transaction friction and enhance supply chain efficiency.",
    id: "digitalinfrastructure",
  },
  {
    img: "https://ajeoba-website.oss-eu-central-1.aliyuncs.com/compressed-images/compressed-images/Input%20Supply.png",
    caption: "Input Supply",
    text: " Ajeoba seeks to provide a wide range of agricultural inputs leveraging technology to connect farmers to high quality products that improve crop health and increase productivity.",
    id: "inputsupply",
  },
  {
    img: "https://ajeoba-website.oss-eu-central-1.aliyuncs.com/compressed-images/compressed-images/Proprietary%20Investment.png",
    caption: "Proprietary Investment",
    text: "Ajeoba is working to build a diversified investment portfolio within the agricultural sector, creating high-yield investment opportunities for investors. These opportunities are open to investors within and outside the agricultural sector.",
    id: "proprietaryinvestment",
  },
  {
    img: "https://ajeoba-website.oss-eu-central-1.aliyuncs.com/compressed-images/compressed-images/Intrinsic%20Database%20%281%29-min.png",
    caption: "Intrinsic Database",
    text: "Ajeoba provides a repository for historical prices, weather analysis, climate predictions, crops planted and yield. Data analytics can help farmers monitor the health of crops in real-time, create predictive analytics related to future yields.",
    id: "intrinsicdatabase",
  },
  {
    img: "https://ajeoba-website.oss-eu-central-1.aliyuncs.com/compressed-images/compressed-images/Financial%20Services.png",
    caption: "Financial Services",
    text: "We bridge the financing gap for smallholder farmers across Nigeria. Using our robust farmer verification and KYC structure, farmers verified on our platform can gain access to small loans & grants to boost agricultural process & increase productivity.",
    id: "financialservices",
  },
  {
    img: "https://ajeoba-website.oss-eu-central-1.aliyuncs.com/compressed-images/compressed-images/Market%20Arbitrage.png",
    caption: "Market Arbitrage",
    text: "Ajeoba seeks to build a thriving commodity market, off taking agricultural commodities and simultaneously selling in larger markets and commodity exchanges. Investors can also can profit from the temporary difference in sale.",
    id: "marketartbitrage",
  },
];

// icon url
const addProduct =
  "https://ajeoba-website.oss-eu-central-1.aliyuncs.com/compressed-images/compressed-images/addProduct.svg";
const refereeSelection =
  "https://ajeoba-website.oss-eu-central-1.aliyuncs.com/compressed-images/compressed-images/refereeSelection.svg";
const landDetails =
  "https://ajeoba-website.oss-eu-central-1.aliyuncs.com/compressed-images/compressed-images/landDetails.svg";
const formerOtpVerification =
  "https://ajeoba-website.oss-eu-central-1.aliyuncs.com/compressed-images/compressed-images/formerOtpVerification.png";
const associationDetailsIcon =
  "https://ajeoba-website.oss-eu-central-1.aliyuncs.com/compressed-images/compressed-images/association_details.svg";
const kycVerificationIcon =
  "https://ajeoba-website.oss-eu-central-1.aliyuncs.com/compressed-images/compressed-images/kyc_verification.svg";
const personalDetailsIcon =
  "https://ajeoba-website.oss-eu-central-1.aliyuncs.com/compressed-images/compressed-images/personal_details.svg";
// images url
const akinola =
  "https://ajeoba-website.oss-eu-central-1.aliyuncs.com/compressed-images/compressed-images/akinola.png";
const pade =
  "https://ajeoba-website.oss-eu-central-1.aliyuncs.com/compressed-images/compressed-images/pade.png";
const babatunde =
  "https://ajeoba-website.oss-eu-central-1.aliyuncs.com/compressed-images/compressed-images/babatunde.png";
const bukola =
  "https://ajeoba-website.oss-eu-central-1.aliyuncs.com/compressed-images/compressed-images/bukola.png";
const mayowa =
  "https://ajeoba-website.oss-eu-central-1.aliyuncs.com/compressed-images/compressed-images/mayowa.png";
const taiwo =
  "https://ajeoba-website.oss-eu-central-1.aliyuncs.com/compressed-images/compressed-images/taiwo.jpg";
const olusegun =
  "https://ajeoba-website.oss-eu-central-1.aliyuncs.com/compressed-images/compressed-images/olusegun.png";
const muktar =
  "https://ajeoba-website.oss-eu-central-1.aliyuncs.com/compressed-images/compressed-images/muktar.png";
const tamara =
  "https://ajeoba-website.oss-eu-central-1.aliyuncs.com/compressed-images/compressed-images/tamara.png";
//
// value icons

export const value_icon_1 = value_icon_1_;
export const value_icon_2 = value_icon_2_;
export const value_icon_3 = value_icon_3_;
export const value_icon_4 = value_icon_4_;
export const value_icon_5 = value_icon_5_;
//
export const imgs = [
  {
    img: "https://ajeoba-website.oss-eu-central-1.aliyuncs.com/compressed-images/compressed-images/Digital%20Infrastructure%20%282%29.png",
    text: "The company’s digital platform primarily creates an interface between sellers (farmers, producers, and aggregators) and buyers (consumers, aggregators, industrials, and exporters) of agricultural products and related transactions leveraging information technology to eliminate transaction friction and enhance supply chain efficiency. To this end, our business model underpinned by our robust software will deliver significant gains in the sector including but not limited to: Quality assurance, Warehousing/inventory, Logistics and traceability, Input supply, etc ",
    caption: "Digital Infrastructure",
    id: "digitalinfrastructure",
  },
  {
    img: "https://ajeoba-website.oss-eu-central-1.aliyuncs.com/compressed-images/compressed-images/Proprietary%20Investment-min.png",
    text: "Ajeoba is working to build a diversified investment portfolio within the agricultural sector, creating high-yield investment opportunities for investors.These opportunities are open to investors within and outside the agricultural for the purpose of testing new investment strategies, instruments or markets. Group subsidiaries can also invest in newly launched titled funds, client funds or SPVs. Such opportunities include",
    caption: "Proprietary Investment",
    id: "proprietaryinvestment",
  },
  {
    img: "https://ajeoba-website.oss-eu-central-1.aliyuncs.com/compressed-images/compressed-images/VP%20-%20Intrinsic%20Database-min.png",
    text: "The paucity of data is prevalent in the agriculture sector and to close this gap, Ajeoba will constantly collect and develop a repository for relevant data within the Agricultural space across Nigeria and overtime, Africa. The availability of relevant and verified data can help farmers create predictive analysis related to future yields and make resource management decisions based on proven trends.Government agencies and relevant stakeholders can also gain access to this data pool to make economic and trade decisions.",
    caption: "Intrinsic Database",
    id: "intrinsicdatabase",
  },
  {
    img: "https://ajeoba-website.oss-eu-central-1.aliyuncs.com/compressed-images/compressed-images/VP%20-%20Financial%20Services%28mobile%29.png",
    text: "Ajeoba seeks to bridge the financing gap for smallholder farmers across Nigeria.Using our robust farmer verification and KYC structure, farmers verified on our platform can gain access to small loans to boost agricultural process. Farmers through registered cooperative associations can apply for international grants and aid to increase productivity.The sole aim  of this is to directly impact the lives of small holder farmers, creating increased all round agricultural yield. Qualified loan amounts will be based on :Historical Farm Yield Current Prices of Commodities ",
    caption: "Financial Services",
    id: "financialservices",
  },
  {
    img: "https://ajeoba-website.oss-eu-central-1.aliyuncs.com/compressed-images/compressed-images/VP%20-%20Market%20Arbitrage%28mobile%29.png",
    text: "Building a B2B2C marketplace for farmers creating seamless linkages to off takers (small or large scale), enabling and facilitating the sale of high-quality agricultural produce.This reduces hands-off and expedites farm-to-market time thereby reducing wastage and regulating pricing/market inefficiencies. By this, farmers have access to large markets, selling off farm produce within days/weeks at a significant margin. Leverage the opportunity of pricing/market inefficiencies by off-taking farm produce at the end of the produce’s season to sell within days/weeks at a significant margin.",
    caption: "Market Arbitrage",
    id: "marketartbitrage",
  },
  {
    img: "https://ajeoba-website.oss-eu-central-1.aliyuncs.com/compressed-images/compressed-images/VP%20-%20Input%20Supply%28web%29-min.png",
    text: "Ajeoba seeks to provide a wide range of agricultural inputs leveraging technology to connect farmers to high quality products that improve crop health and increase productivity. Inputs such a Organic fertilizers, high quality seeds, pesticides and herbicides as well as modern and tech based farm equipments.",
    caption: "Input Supply",
    id: "inputsupply",
  },
];

// HOMEPAGE RESIZED IMAGES PLS DO NOT TAMPER WITH!!!!!! TENKS//
export const bannerimg =
  "https://ajeoba-website.oss-eu-central-1.aliyuncs.com/websiteImagesNew/homepage/homepageBanner.svg";
export const bannerimgsm =
  "https://ajeoba-website.oss-eu-central-1.aliyuncs.com/websiteImagesNew/homepage/homepageBannersmobile.svg";
export const exploreimg =
  "https://ajeoba-website.oss-eu-central-1.aliyuncs.com/websiteImagesNew/homepage/explorequalityfarmproductimage.svg";
export const valuepropgrrnsmilingmanrightside =
  "https://ajeoba-website.oss-eu-central-1.aliyuncs.com/websiteImagesNew/homepage/homepagevalueprpsmilingmanholdingcabbage.svg";
export const handholdingmanure =
  "https://ajeoba-website.oss-eu-central-1.aliyuncs.com/websiteImagesNew/homepage/homepagevalueprophandholdingmanuer.svg";
export const greenbgwhoneedssoftwaredesktop =
  "https://ajeoba-website.oss-eu-central-1.aliyuncs.com/websiteImagesNew/homepage/homepagewhoneedssoftwaregreenbakgroundbigscreen.svg";
export const dashboardsoftwarewhoneedssoftware =
  "https://ajeoba-website.oss-eu-central-1.aliyuncs.com/websiteImagesNew/homepage/whonnedsoftwaredashboard.svg";
export const exploremobileappbackground =
  "https://ajeoba-website.oss-eu-central-1.aliyuncs.com/websiteImagesNew/homepage/exploremobileapsssectionflowerbg.svg";
export const exploremobileappactualmobileohonedeaktop =
  "https://ajeoba-website.oss-eu-central-1.aliyuncs.com/websiteImagesNew/homepage/homepagedesktopphone.svg";
export const exploremobileappactualmobileohonesmallphone =
  "https://ajeoba-website.oss-eu-central-1.aliyuncs.com/websiteImagesNew/homepage/homepagemobilephonemobile.svg";
export const testimonialsdesktopbackground =
  "https://ajeoba-website.oss-eu-central-1.aliyuncs.com/websiteImagesNew/homepage/testimonaialbg.svg";
export const testimonialsbackgroundmobile =
  "https://ajeoba-website.oss-eu-central-1.aliyuncs.com/websiteImagesNew/homepage/testimonialsbgimagemobile.svg";

//WNSPAGE
export const whoneedsbannerdesktop =
  "https://ajeoba-website.oss-eu-central-1.aliyuncs.com/websiteImagesNew/whoneedssoftwarepage/whoneedssoftwaer/banner.svg";

export const whoneedsbannermobile =
  "https://ajeoba-website.oss-eu-central-1.aliyuncs.com/websiteImagesNew/whoneedssoftwarepage/whoneedssoftwaer/waremobile.svg";

export const farmingassimg1 =
  "https://ajeoba-website.oss-eu-central-1.aliyuncs.com/websiteImagesNew/whoneedssoftwarepage/whoneedssoftwaer/farmngasssociaton1.svg";
export const farmingassimg2 =
  "https://ajeoba-website.oss-eu-central-1.aliyuncs.com/websiteImagesNew/whoneedssoftwarepage/whoneedssoftwaer/farmngasssociaton2.svg";
export const farmingassimg3 =
  "https://ajeoba-website.oss-eu-central-1.aliyuncs.com/websiteImagesNew/whoneedssoftwarepage/whoneedssoftwaer/farmngasssociaton3.svg";

export const qaguy =
  "https://ajeoba-website.oss-eu-central-1.aliyuncs.com/websiteImagesNew/whoneedssoftwarepage/whoneedssoftwaer/QAguy.svg";

export const logcompanybdekstop =
  "https://ajeoba-website.oss-eu-central-1.aliyuncs.com/websiteImagesNew/whoneedssoftwarepage/whoneedssoftwaer/logomp.svg";

export const logcompanymobile =
  "https://ajeoba-website.oss-eu-central-1.aliyuncs.com/websiteImagesNew/whoneedssoftwarepage/whoneedssoftwaer/logisticcomobgmobile.svg";
export const inputsupplier1 =
  "https://ajeoba-website.oss-eu-central-1.aliyuncs.com/websiteImagesNew/whoneedssoftwarepage/whoneedssoftwaer/inputsupply.svg";

export const corpobuyerlady =
  "https://ajeoba-website.oss-eu-central-1.aliyuncs.com/websiteImagesNew/whoneedssoftwarepage/whoneedssoftwaer/corporatebuy.svg";

export const otherperosnas4 =
  "https://ajeoba-website.oss-eu-central-1.aliyuncs.com/websiteImagesNew/whoneedssoftwarepage/whoneedssoftwaer/fi%20ancecomp%3B.svg";
export const otherperosnas2 =
  "https://ajeoba-website.oss-eu-central-1.aliyuncs.com/websiteImagesNew/whoneedssoftwarepage/whoneedssoftwaer/fiancecompsm.svg";

// VALUEPROP PAGE
export const valuepropbannerdesktop =
  "https://ajeoba-website.oss-eu-central-1.aliyuncs.com/websiteImagesNew/valueprop/valuepropbanner.svg";
export const valuepropbannermobile =
  "https://ajeoba-website.oss-eu-central-1.aliyuncs.com/websiteImagesNew/valueprop/valuepropbannermobile.svg";
export const valuepropdigitalinfrasture =
  "https://ajeoba-website.oss-eu-central-1.aliyuncs.com/websiteImagesNew/valueprop/valueproppageDigital%20Infrastructure.svg";
export const valueproppropinvflower =
  "https://ajeoba-website.oss-eu-central-1.aliyuncs.com/websiteImagesNew/valueprop/valueporpflowepropinestment.svg";
export const valuepropintridatbase =
  "https://ajeoba-website.oss-eu-central-1.aliyuncs.com/websiteImagesNew/valueprop/valuepropindatabsebig.svg";
export const valuepropintridatbasemobile =
  "https://ajeoba-website.oss-eu-central-1.aliyuncs.com/websiteImagesNew/valueprop/valuepropintridatbasemobile.svg";
export const valuepropintridatbasemobilenew =
  "https://ajeoba-website.oss-eu-central-1.aliyuncs.com/websiteImagesNew/valueprop/valuepropintridatbasemobilenew.svg";
export const valuepropmarketarbitargedesktop =
  "https://ajeoba-website.oss-eu-central-1.aliyuncs.com/websiteImagesNew/valueprop/marketarbitragebig.svg";
export const valuepropinputsupplychildimages1 =
  "https://ajeoba-website.oss-eu-central-1.aliyuncs.com/websiteImagesNew/valueprop/inputsupply1.svg";
export const valuepropinputsupplychildimages2 =
  "https://ajeoba-website.oss-eu-central-1.aliyuncs.com/websiteImagesNew/valueprop/inputsupply2.svg";
export const valuepropinputsupplychildimages3 =
  "https://ajeoba-website.oss-eu-central-1.aliyuncs.com/websiteImagesNew/valueprop/inputsupply3.svg";

// ABIUT US PAGE

export const firsrtsection =
  "https://ajeoba-website.oss-eu-central-1.aliyuncs.com/websiteImagesNew/aboutus/detailsimg.svg";

export const corevalues = [
  {
    name: "Service & Delivery Excellence",
    text: "Employ the best available human resources and technology to ensure a seamless experience with services, products and platforms.",
    img: "https://ajeoba-website.oss-eu-central-1.aliyuncs.com/websiteImagesNew/aboutus/corevalue1.svg",
  },
  {
    name: "Customer Value Creation",
    text: "Our users are our raison d’être; we strive to create the best outcomes for our users with relevant, targeted and creative solution.",
    img: "https://ajeoba-website.oss-eu-central-1.aliyuncs.com/websiteImagesNew/aboutus/corevalue2.svg",
  },
  {
    name: "Integrity & Professionalism",
    text: "Adhere to the moral and ethical principles required, and imbibe the highest levels of professionalism.",
    img: "https://ajeoba-website.oss-eu-central-1.aliyuncs.com/websiteImagesNew/aboutus/corevalue3.svg",
  },
  {
    name: "Digital Thinking & Innovation",
    text: "To constantly improve our services, leveraging digital platforms and world class technology.",
    img: "https://ajeoba-website.oss-eu-central-1.aliyuncs.com/websiteImagesNew/aboutus/corevalue4.svg",
  },
  {
    name: "Data Driven Approach",
    text: "Data Driven Approach: Collaborate closely with all stakeholders to achieve our shared vision",
    img: "https://ajeoba-website.oss-eu-central-1.aliyuncs.com/websiteImagesNew/aboutus/corevalue5.svg",
  },
];

export const boardpeople = [
  {
    name: "Babatunde William-Funmilayo",
    role: "Founder and Managing Director of Ajeoba Agro-Exchange Limited",
    img: "https://ajeoba-website.oss-eu-central-1.aliyuncs.com/websiteImagesNew/aboutus/mdboardimg.png",
  },
  {
    name: "Bukola Akanni-Aluko",
    role: "Founder and Managing Director of Crepe du Jour Nigeria",
    img: "https://ajeoba-website.oss-eu-central-1.aliyuncs.com/websiteImagesNew/aboutus/board2.svg",
  },
  {
    name: "Olusegun and Taiye Apoeso",
    role: "Nigerian-American medical doctors",
    img: "https://ajeoba-website.oss-eu-central-1.aliyuncs.com/websiteImagesNew/aboutus/board3.svg",
  },
  {
    name: "Pade Durotoye",
    role: "Executive Chairman and Founder of Engenious Nigeria Limited",
    img: "https://ajeoba-website.oss-eu-central-1.aliyuncs.com/websiteImagesNew/aboutus/pade.png",
  },
  {
    name: "Taiwo Durotoye",
    role: "Founder and Creative Director of Donna Tyler Ltd",
    img: "https://ajeoba-website.oss-eu-central-1.aliyuncs.com/websiteImagesNew/aboutus/taiwo.png",
  },
];
export const managestaff = [
  {
    img: "https://ajeoba-website.oss-eu-central-1.aliyuncs.com/websiteImagesNew/aboutus/staff1.svg",
    name: "Tamara Bestman",
    role: "Lead, Business Operations",
  },
  {
    img: "https://ajeoba-website.oss-eu-central-1.aliyuncs.com/websiteImagesNew/aboutus/staff2.svg",
    name: "Mayowa Oluwashina",
    role: "Chief Technology Officer",
  },
  {
    img: "https://ajeoba-website.oss-eu-central-1.aliyuncs.com/websiteImagesNew/aboutus/staff3.svg",
    name: "Muktar Usman",
    role: "Product/Project Manager",
  },
];

export const banner =
  "https://ajeoba-website.oss-eu-central-1.aliyuncs.com/websiteImagesNew/aboutus/bannerdesktop.svg";
export const bannermobile =
  "https://ajeoba-website.oss-eu-central-1.aliyuncs.com/websiteImagesNew/aboutus/bannermobile.svg";
export const firssection =
  "https://ajeoba-website.oss-eu-central-1.aliyuncs.com/websiteImagesNew/aboutus/missionimg.svg";
export const vission =
  "https://ajeoba-website.oss-eu-central-1.aliyuncs.com/websiteImagesNew/aboutus/vissionimg.svg";
export const mission =
  "https://ajeoba-website.oss-eu-central-1.aliyuncs.com/websiteImagesNew/aboutus/missionimg.svg";

// MAERKETPLACEDETAILFLOWER
export const marketplacefloer =
  "https://ajeoba-website.oss-eu-central-1.aliyuncs.com/website%20images/marketplacedetailflower.svg";

export const MIN_AGE = 18;
export const MOBILE_NUMBER_REGEX = new RegExp("^(?!0+$)[0-9]{9,15}$");
export const PASSWORD_REGEX_WITH_SPECIAL_CHARACTERS =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,20}$)/;
export const PASSWORD_REGEX =
  /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d@$!%*#?&]{8,20}$/;
export const ACCOUNT_HOLDER_NAME_REGEX = /^[A-Za-z ]+$/;
export const BANK_NAME_REGEX = /^[A-Za-z ]+$/;
export const SEARCH_FILTER_REGEX = /^\w*$/;
export const ZIP_CODE_REGEX = /^\d*$/;
export const ONLY_CHAR_REGEX = /^[A-Za-z]{2,20}$/;

export const PASSWORD_ENCRYPTION_ALGO = "AES";
export const PASSWORD_ENCRYPTION_SECRET =
  "BgfQWII2oANwK4CZFI9v3jsMR6sH9QIWAG4kgTV809m79XBtyYsge24Qt4wtvtS";
export const LIMIT = 10;
export const LIMITOPENMARKETPLACE = 5;
export const SKIP = 0;
export const CARD_LIMIT = 12;
export const MARKETPLACELIST_LIMIT = 15;
export const DETAILSPAGE_LIMIT = 8;

export const board = [
  {
    image: babatunde,
    name: "Babatunde William-Funmilayo",
    office: "Founder and Managing Director of Ajeoba Agro-Exchange Limited",
  },
  {
    image: olusegun,
    name: "Olusegun and Taiye Apoeso",
    office: "Nigerian-American medical doctors",
  },
  {
    image: bukola,
    name: "Bukola Akanni-Aluko",
    office: "Founder and Managing Director of Crepe du Jour Nigeria",
  },
  {
    image: pade,
    name: "Pade Durotoye",
    office: "Executive Chairman and Founder of Engenious Nigeria Limited",
  },
  {
    image: taiwo,
    name: "Taiwo Durotoye",
    office: "Founder and Creative Director of Donna Tyler Ltd",
  },
];

export const management = [
  {
    image: tamara,
    name: "Tamara Bestman",
    office: "Lead, Business Operations",
  },
  {
    image: mayowa,
    name: "Mayowa Oluwashina",
    office: "Chief Technology Officer",
  },
  {
    image: muktar,
    name: "Muktar Usman",
    office: "Project Manager",
  },
  {
    image: akinola,
    name: "Akinwale Akinola",
    office: "Chief Strategy Officer",
  },
];

export const core_values = [
  {
    icon: value_icon_1,
    persona: "Customer Value Creation",
    value:
      "Our users are our raison d’être; we strive to create the best outcomes for our users with relevant, targeted and creative solution.",
  },
  {
    icon: value_icon_2,
    persona: "Service & Delivery Excellence",
    value:
      "Employ the best available human resources and technology to ensure a seamless experience with services, products and platforms.",
  },
  {
    icon: value_icon_3,
    persona: "Integrity & Professionalism",
    value:
      "Adhere to the moral and ethical principles required, and imbibe the highest levels of professionalism.",
  },
  {
    icon: value_icon_4,
    persona: "Digital Thinking & Innovation",
    value:
      "To constantly improve our services, leveraging digital platforms and world class technology.",
  },
  {
    icon: value_icon_5,
    persona: "Data Driven Approach",
    value:
      "Data Driven Approach: Collaborate closely with all stakeholders to achieve our shared vision.",
  },
];

export const kycStatusOptions = [
  {
    label: "Verified",
    value: "Verified",
  },
  {
    label: "UnVerified",
    value: "Unverified",
  },
];
export const subStatusOptions = [
  {
    label: "Active",
    value: "Active",
  },
  {
    label: "InActive",
    value: "Inactive",
  },
];
export const subscriptionMethodOptions = [
  {
    label: "Select Farmer",
    value: "selectfarmer",
  },
  {
    label: "Collective",
    value: "collective",
  },
];

export const genderOptions = [
  {
    label: "Male",
    value: "MALE",
  },
  {
    label: "Female",
    value: "FEMALE",
  },
  {
    label: "Other",
    value: "TRANSGENDER",
  },
];
export const UIN_TYPE_VALUE = [
  {
    label: "NIN",
    value: "NIN",
  },
  {
    label: "VOTERS IDENTIFICATION NUMBER",
    value: "VOTERS_IDENTIFICATION_NUMBER",
  },
  {
    label: "NATIONAL ID",
    value: "NATIONAL_ID",
  },
];

export const signUpStepOptions = [
  {
    label: "Personal details",
    icon: <img src={personalDetailsIcon} alt="icon" />,
  },
  {
    label: "Association details",
    icon: <img src={associationDetailsIcon} alt="icon" />,
  },
  {
    label: "KYC verification",
    icon: <img src={kycVerificationIcon} alt="icon" />,
  },
];

export const customSignUpStepOptions = [
  {
    label: "Aggregator details",
    icon: <img src={associationDetailsIcon} alt="icon" />,
  },
  {
    label: "QA Company details",
    icon: <img src={associationDetailsIcon} alt="icon" />,
  },
  {
    label: "Corporate Buyer details",
    icon: <img src={associationDetailsIcon} alt="icon" />,
  },
  {
    label: "Logistics Company details",
    icon: <img src={associationDetailsIcon} alt="icon" />,
  },
  {
    label: "Buyer details",
    icon: <img src={associationDetailsIcon} alt="icon" />,
  },
];

export const employmentOption = [
  {
    label: "Employed",
    value: "EMPLOYED",
  },
  {
    label: "Self-Employed",
    value: "SELF_EMPLOYED",
  },
  {
    label: "Retired",
    value: "RETIRED",
  },
  {
    label: "Unemployed",
    value: "UNEMPLOYED",
  },
  {
    label: "Student",
    value: "STUDENT",
  },
];

export const durationOption = [
  {
    label: "Basic",
    value: "2",
  },
  {
    label: "Premium",
    value: "6",
  },
];

export const logisticDecision = [
  {
    label: "Self Manage",
    value: "SELF_MANAGE",
  },
  {
    label: "Merchant",
    value: "ALLOW_MERCHANT",
  },
  {
    label: "Post Ads",
    value: "POST_ADS",
  },
];

export const taxOptions = [
  {
    label: "Yes, I have",
    value: "yes",
  },
  {
    label: "No, I don't have",
    value: "no",
  },
];

export const addItemOptions = [
  {
    label: "Single item",
    value: "Single_Item",
  },
  {
    label: "Bulk items",
    value: "Bulk_Item",
  },
];

export const itemTypeOptions = [
  {
    label: "Farmer Certificate",
    value: "FARMER_CERTIFICATE",
  },
  {
    label: "QA Certificate",
    value: "QA_CERTIFICATE",
  },
  {
    label: "Soil Type",
    value: "SOIL_TYPE",
  },
  {
    label: "Type of Truck",
    value: "TYPE_OF_TRUCK",
  },
  {
    label: "Warehouse Facility",
    value: "WAREHOUSE_FACILITY",
  },
  {
    label: "Warehouse Certificate",
    value: "WAREHOUSE_CERTIFICATE",
  },
];
export const productOptions = [
  {
    label: "Single Product",
    value: "single_product",
  },
  {
    label: "Bulk Products",
    value: "bulk_product",
  },
];

export const inputOptions = [
  {
    label: "Single Input",
    value: "single_input",
  },
  {
    label: "Bulk Inputs",
    value: "bulk_input",
  },
];

export const itemTypeListingOptions = [
  {
    label: "All",
    value: null,
  },
  {
    label: "Farmer Certificate",
    value: "FARMER_CERTIFICATE",
  },

  {
    label: "QA Certificate",
    value: "QA_CERTIFICATE",
  },

  {
    label: "Soil Type",
    value: "SOIL_TYPE",
  },

  {
    label: "Type of Truck",
    value: "TYPE_OF_TRUCK",
  },
  {
    label: "Warehouse Facility",
    value: "WAREHOUSE_FACILITY",
  },
  {
    label: "Warehouse Certificate",
    value: "WAREHOUSE_CERTIFICATE",
  },
];

export const measurementOptions = [
  {
    label: "Kg",
    value: "KG",
  },
  {
    label: "Ton",
    value: "TON",
  },
  {
    label: "Litre",
    value: "LITRE",
  },
  {
    label: "Gallon",
    value: "GALLON",
  },
  {
    label: "Count",
    value: "COUNT",
  },
];

export const typeOfSoilOptions = [
  {
    label: "SAND SOIL",
    value: "SAND_SOIL",
  },
  {
    label: "PEAT SOIL",
    value: "PEAT_SOIL",
  },
  {
    label: "CHALK SOIL",
    value: "CHALK_SOIL",
  },
  {
    label: "SLIT SOIL",
    value: "SLIT_SOIL",
  },
  {
    label: "LOAM SOIL",
    value: "LOAM_SOIL",
  },
  {
    label: "CLAY SOIL",
    value: "CLAY_SOIL",
  },
];

export const productBulkUploadNoteText = [
  "The file should be a .csv file",
  "Product names should be present in the 1st column of the CSV file.",
  "Unit of Measurement (KG, TON, LITRE , GALLON, COUNT) should be present in the 2nd column of the CSV file.",
  "Product names should begin from the 1st cell of the CSV file.",
];

export const farmerBulkUploadNoteText = [
  "The file should be a .csv file",
  "First column in the sample csv represents headers",
  "Each row entry will create a new farmer",
  "Zipcode, Tax id, Address-line 2, Bank account holder name, Bank name and  Account number are optional fields",
  "Valid Employment Types are : EMPLOYED, SELF_EMPLOYED, RETIRED, UNEMPLOYED, STUDENT",
  "Date of Birth format : MM-DD-YYYY (10-14-2001)",
  "Phone number should be unique",
  "Tax id should be a positive integer of length 2 to 20",
  "Zipcode should be positive integer of length 5 to 10",
];

export const itemBulkUploadNoteText = [
  "The file should be a .csv file",
  "Item names should be present in the 1st column of the CSV file.",
  "Item names should begin from the 1st cell of the CSV file.",
];

export const inputBulkUploadNoteText = [
  "The file should be a .csv file",
  "Input names should be present in the 1st column of the CSV file.",
  "Unit of Measurement (KG, TON, LITRE , GALLON, COUNT) should be present in the 2nd column of the CSV file.",
  "Input names should begin from the 1st cell of the CSV file.",
];

export const opportunities = [
  "This enables the subscribed farmers to aggregate their products on the Ajeoba's Marketplace",
  "This enables the subscribed farmers to have access to the financial services",
];

export const completeKycVNINOptions = [
  {
    label: "Farmer KYC verification",
    icon: <img src={formerOtpVerification} />,
  },
  {
    label: "Farmer OTP verification",
    icon: <img src={kycVerificationIcon} />,
  },
  {
    label: "Referee selection",
    icon: <img src={refereeSelection} />,
  },
];

export const addFarmerOptions = [
  {
    label: "Farmer OTP verification",
    icon: <img src={formerOtpVerification} />,
  },
  {
    label: "Personal details",
    icon: <img src={personalDetailsIcon} />,
  },
  {
    label: "Farmer KYC verification",
    icon: <img src={kycVerificationIcon} />,
  },
  {
    label: "Land details",
    icon: <img src={landDetails} />,
  },
  {
    label: "Add product",
    icon: <img src={addProduct} />,
  },
  {
    label: "Referee selection",
    icon: <img src={refereeSelection} />,
  },
  {
    label: "Process Completed",
    icon: <img src={kycVerificationIcon} />,
  },
];

export const orderTracker = [
  {
    label: "Order Placed",
    icon: <img src={formerOtpVerification} />,
  },
  {
    label: "Ongoing",
    icon: <img src={landDetails} />,
  },
  {
    label: "In-Transit",
    icon: <img src={landDetails} />,
  },
  {
    label: "Completed",
    icon: <img src={landDetails} />,
  },
];

export const wareHouseFacilityListType = {
  itemType: "WAREHOUSE_FACILITY",
};

export const qaCertificateListType = {
  itemType: "QA_CERTIFICATE",
};

export const productTypeOptions = [
  {
    label: "Livestock",
    value: "LIVESTOCK",
  },
  {
    label: "Dry",
    value: "DRY",
  },
  {
    label: "Refrigerated",
    value: "REFRIGERATED",
  },
];
export const allProductOptions = [
  // "all", "farm-produce", "value-added"
  {
    label: "All",
    value: "all",
  },
  {
    label: "Farm produce",
    value: "farm-produce",
  },
  {
    label: "Value added",
    value: "value-added",
  },
  // {
  //   label: "Inputs",
  //   value: "INPUT",
  // },
];
export const productTypeOptionsLandingPage = [
  {
    label: "All",
    value: "All",
  },
  {
    label: "Livestock",
    value: "LIVESTOCK",
  },
  {
    label: "Dry",
    value: "DRY",
  },
  {
    label: "Refrigerated",
    value: "REFRIGERATED",
  },
];

export const qualityOptions = [
  {
    label: "A+",
    value: "1",
  },
  {
    label: "A",
    value: "2",
  },
  {
    label: "B+",
    value: "3",
  },
  {
    label: "B",
    value: "4",
  },
  {
    label: "C",
    value: "5",
  },
  {
    label: "D",
    value: "6",
  },
];

export const sendAdOption = [
  {
    label: "Open for all",
    value: 1,
  },
  {
    label: "Specific company",
    value: 2,
  },
];

export const typeOfBatchOptions = [
  {
    label: "Retail",
    value: "RETAIL",
  },
  {
    label: "Wholesale",
    value: "WHOLESALE",
  },
];

export const typeOfRequestOptions = [
  {
    label: "Product",
    value: "PRODUCT",
  },
  {
    label: "Input",
    value: "INPUT",
  },
];

export const isEnabledOption = [
  { label: "Yes", value: true },
  { label: "No", value: false },
];

export const statusOptions = [
  { label: "Active", value: "ACTIVE" },
  { label: "Inactive", value: "INACTIVE" },
  { label: "Archived", value: "ARCHIVED" },
];

export const reportStatusOption = [
  { label: "Failed", value: "FAILED" },
  { label: "Passed", value: "PASSED" },
];

export const subscriptionNote =
  "If the status of the plan is set as active, then the plan will be immediately available to the respective user role for selection after it is created.";

export const IMAGE_URL = "https://ajeoba-developer.s3.ap-south-1.amazonaws.com";

export const minFilesAllowedForPhotoOfTruck = 1;
export const maxFilesAllowedForPhotoOfTruck = 10;

export const productOrderStatusOptions = [
  { label: "All", value: null },
  { label: "Order Placed", value: "ORDER_PLACED" },
  { label: "Ongoing", value: "ONGOING" },
  { label: "In-transit", value: "IN-TRANSIT" },
  { label: "Completed", value: "COMPLETED" },
];

export const productCategoriesOptions = [
  { label: "All", value: null },
  { label: "Live Stock", value: "LIVE_STOCK" },
  { label: "Seeds", value: "SEEDS" },
  { label: "Fertilzers", value: "FERTILIZERS" },
  { label: "Grains", value: "GRAINS" },
];

export const orderTypeOptions = [
  {
    productOrders: "product_orders",
    inputOrders: "input_orders",
  },
];

export const distanceOptions = [
  { label: "0-200 Km", distanceMin: 0, distanceMax: 200 },
  { label: "200-500 Km", distanceMin: 201, distanceMax: 500 },
  { label: "500-1000 Km", distanceMin: 501, distanceMax: 1000 },
  { label: "1000 Km +", distanceMin: 1001 },
];

export const userRoleTypeListingOptions = [
  {
    label: "All",
    value: null,
    roleId: null,
  },
  {
    label: "Farming Association",
    value: "FARMING_ASSOCIATION",
    roleId: 1,
  },

  {
    label: "Product Aggregator",
    value: "PRODUCT_AGGREGATOR",
    roleId: 2,
  },

  {
    label: "QA company",
    value: "QA_COMPANY",
    roleId: 3,
  },

  {
    label: "Logistics Company",
    value: "LOGISTICS_COMPANY",
    roleId: 4,
  },
  {
    label: "Single Buyer",
    value: "SINGLE_BUYER",
    roleId: 5,
  },
  {
    label: "Corporate Buyer",
    value: "CORPORATE_BUYER",
    roleId: 6,
  },
  {
    label: "Farmer",
    value: "FARMER",
    roleId: 7,
  },
  {
    label: "Finance Comapny",
    value: "FINANCE_COMPANY",
    roleId: 8,
  },
  {
    label: "Input Supplier",
    value: "INPUT_SUPPLIER",
    roleId: 9,
  },
  {
    label: "Admin",
    value: "ADMIN",
    roleId: 10,
  },
  {
    label: "Super Admin",
    value: "SUPER_ADMIN",
    roleId: 11,
  },
];
export const adTypeOptions = [
  { label: "Ad Placed", value: "ACTIVE" },
  { label: "Ad not Placed", value: "INACTIVE" },
  { label: "Archived", value: "ARCHIVED" },
];

// Update heading constant
export const farmingAssociationDashboardHaeders = [
  { label: "Farmers Onboarded", key: "farmersOnboard" },
  { label: "Unverified Farmers", key: "unverifiedFarmers" },
  { label: "Input puchased", key: "numberOfInputPurchase" },
  { label: "Product aggregated", key: "numberOfProductAggregated" },
  { label: "Sales revenue", key: "salesrevenue" },
];

export const blog_contents = [
  {
    title: "Agriculture made smarter with Ajeoba",
    body: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Eligendi non quis exercitationem culpa nesciunt nihil aut nostrum explicabo reprehenderit optio amet ab temporibus asperiores quasi cupiditate. Voluptatum ducimus voluptates voluptas?",
    image: blog_image,
  },
  {
    title: "Agriculture made smarter with Ajeoba",
    body: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Eligendi non quis exercitationem culpa nesciunt nihil aut nostrum explicabo reprehenderit optio amet ab temporibus asperiores quasi cupiditate. Voluptatum ducimus voluptates voluptas?",
    image: blog_image,
  },
  {
    title: "Agriculture made smarter with Ajeoba",
    body: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Eligendi non quis exercitationem culpa nesciunt nihil aut nostrum explicabo reprehenderit optio amet ab temporibus asperiores quasi cupiditate. Voluptatum ducimus voluptates voluptas?",
    image: blog_image,
  },
  {
    title: "Agriculture made smarter with Ajeoba",
    body: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Eligendi non quis exercitationem culpa nesciunt nihil aut nostrum explicabo reprehenderit optio amet ab temporibus asperiores quasi cupiditate. Voluptatum ducimus voluptates voluptas?",
    image: blog_image,
  },
  {
    title: "Agriculture made smarter with Ajeoba",
    body: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Eligendi non quis exercitationem culpa nesciunt nihil aut nostrum explicabo reprehenderit optio amet ab temporibus asperiores quasi cupiditate. Voluptatum ducimus voluptates voluptas?",
    image: blog_image,
  },
  {
    title: "Agriculture made smarter with Ajeoba",
    body: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Eligendi non quis exercitationem culpa nesciunt nihil aut nostrum explicabo reprehenderit optio amet ab temporibus asperiores quasi cupiditate. Voluptatum ducimus voluptates voluptas?",
    image: blog_image,
  },
  {
    title: "Agriculture made smarter with Ajeoba",
    body: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Eligendi non quis exercitationem culpa nesciunt nihil aut nostrum explicabo reprehenderit optio amet ab temporibus asperiores quasi cupiditate. Voluptatum ducimus voluptates voluptas?",
    image: blog_image,
  },
];

export const farmingAssociationSubHeader = [
  { label: "Subscribed Farmers", key: "subscribedFarmerCount" },
  { label: "UnSubscribed Farmers", key: "unsubscribedFarmerCcount" },
];

export const manageLogisticsApprovalOptions = [
  { label: "ONHOLD", key: "Onhold" },
  { label: "REJECTED", key: "rejected" },
  { label: "APPROVED", key: "Approved" },
];

export const productsAggregatorDashboardHeaders = [
  { label: "Product aggregated", key: "numberOfProductAggregated" },
  { label: "Sales revenue", key: "salesrevenue" },
];

export const inputSupplierDashboardHaeders = [
  { label: "Input aggregated", key: "numberOfInputAggregated" },
  { label: "Sales revenue", key: "salesrevenue" },
];

export const adminDashboardHeaders = [
  { label: "Active Associations", key: "activeFarmingAssociation" },
  { label: "Active Farmers", key: "activeFinanceCompany" },
  { label: "Active Aggregators", key: "activeAggregator" },
  // { label: "Active Buyers", key: "activeBuyer" },
  { label: "Active Corporate Buyers", key: "activeCorporateBuyer" },
  { label: "Active Logistic Companies", key: "activeLogisticsCompany" },
  { label: "Active QA Companies", key: "activeQaCompany" },
  { label: "Active Input Suppliers", key: "activeInputSupplier" },
  { label: "Active Finance Companies", key: "activeFinanceCompany" },
  {
    label: "Active Farming Association's Subscription",
    key: "activeFarmingAssociationSubscription",
  },
  { label: "Active Admins", key: "activeAdmin" },
];

export const roleBasedOptionsRevenue = [
  {
    label: "All",
    value: null,
    roleId: null,
  },
  {
    label: "Farming Association",
    value: "FARMING_ASSOCIATION",
    roleId: 1,
  },

  {
    label: "Product Aggregator",
    value: "PRODUCT_AGGREGATOR",
    roleId: 2,
  },
  {
    label: "Input Supplier",
    value: "INPUT_SUPPLIER",
    roleId: 9,
  },
];

export const keyLabelForErros = [
  { label: "Country code", key: "countryCode" },
  { label: "Mobile number", key: "mobileNumber" },
  { label: "First name", key: "firstName" },
  { label: "Last name", key: "lastName" },
  { label: "Gender", key: "gender" },
  { label: "Date of birth", key: "dateOfBirth" },
  { label: "Employment type", key: "employmentType" },
  { label: "Experience", key: "experienceYears" },
  { label: "Address 1", key: "address1" },
  { label: "Country", key: "country" },
  { label: "State", key: "state" },
  { label: "City", key: "city" },
];
